import HeartImage from '@assets/LoadingAnimation/heart.png';

import s from './LoadingAnimation.module.css';

const LOADING_TITLES = [
  'Loading…',
  'Just a sec…',
  'Hang tight!',
  'Almost there…',
  'Preparing…',
  'Getting things ready…',
  'One moment…',
];

type LoadingAnimationProps = {
  compact?: boolean;
};

function LoadingAnimation({ compact = false }: LoadingAnimationProps) {
  return (
    <div className={`${s.loadingContainer} ${compact ? s.compact : ''}`}>
      <div className={s.loader}></div>
      <img alt="heart-image" src={HeartImage} className={s.heartImage} />
      <p className={s.lodaerTitle}>
        {LOADING_TITLES[Math.floor(Math.random() * LOADING_TITLES.length)]}
      </p>
    </div>
  );
}

export default LoadingAnimation;
